import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  TableWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
    "& .pagination-wrapper": {
      "& .MuiTablePagination-select": {
        paddingRight: "24px !important",
      },
      "@media (max-width: 575px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "15px",
      },
      "@media (max-width: 374px)": {
        padding: "0",
      },
    },
  },
  customJobTable: {
    marginTop: 25,
    maxHeight: 680,
    boxShadow: "none",
    "& .MuiTable-root": {
      minWidth: 1700,
      tableLayout: "fixed",
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "30px 19px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          verticalAlign: "top",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "22px 19px",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
          "&.status": {
            "& span": {
              position: "relative",
              paddingLeft: 20,
              display: "block",
              "&:before": {
                content: '""',
                position: "absolute",
                backgroundColor: colors.black,
                height: 10,
                width: 10,
                borderRadius: "50%",
                left: 0,
                top: 7,
              },
            },
            "&.in-progress": {
              "& span": {
                color: colors.green,
                "&:before": {
                  backgroundColor: colors.green,
                },
              },
            },
            "&.assigned": {
              "& span": {
                color: colors.orange,
                "&:before": {
                  backgroundColor: colors.orange,
                },
              },
            },
            "&.review-completed": {
              "& span": {
                color: colors.darkGreen,
                "&:before": {
                  backgroundColor: colors.darkGreen,
                },
              },
            },
            "&.completed": {
              "& span": {
                color: colors.gray2,
                "&:before": {
                  backgroundColor: colors.gray2,
                },
              },
            },
          },
          "&.MuiTableCell-body": {
            wordBreak: "break-word",
          }
        },
      },
      "& .MuiTableRow-root": {
        "&.accordian-row": {
          transition: "all 0.3s",
          cursor: "pointer",
        },
        "&.sub-row": {
          "& .MuiTableSubRoW": {
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: "#f6f6f6",
            "& .consolidated-job-collapse": {
              margin: "0px 20px 0px 50px",
            },
            "& .consolidated-job": {
              border: "2px solid #E7E9EC",
              borderRadius: "6px",
              boxShadow: "-1px 2px 19px -4px rgba(231, 233, 236, 1)",
              backgroundColor: "#ffffff",
            }
          },
          "& .MuiTableCell-root": {
            "&:first-child": {
              paddingLeft: "0px",
            },
            "&:last-child": {
              paddingRight: "0px",
            },
            "&.MuiTableCell-head": {
              backgroundColor: "#E7E9EC",
            },
            "& .MuiCollapse-wrapper": {
              margin: "10px 0",
            },
            "& .MuiTable-root": {
              minWidth: 1600,
              "& .MuiTableRow-root": {
                cursor: "default",
              },
              backgroundColor: "#f6f6f6",
              "& .MuiTableCell-root": {
                padding: "8px 20px",
              },
            },
          },
        },
      },
      "& .check": {
        width: "30px",
      },
      "& .jobId": {
        width: "120px",
        whiteSpace: "nowrap",
        "& .prime-job": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .badge": {
          display: "inline-flex",
          alignItems: "center",
          marginLeft: 8,
          padding: "2px 8px",
          fontSize: 11,
          fontWeight: 600,
          color: colors.white,
          backgroundColor: colors.primary,
          borderRadius: 6,
          letterSpacing: 0.4,
          textTransform: "uppercase",
        },
        "& .consolidated-job-arrow": {
          transition: "transform 0.3s",
          fill: colors.gray2,
          "&.active": {
            transform: "translateY(0) rotate(0deg)",
          },
          "&.not-active": {
            transform: "translateY(0) rotate(-90deg)",
          },
        },
      },
      "& .city": {
        width: "120px",
      },
      "& .driver": {
        width: "140px",
        wordWrap: "break-word",
        "& .re-assign-link": {
          color: colors.primary,
          cursor: "pointer",
        },
        "&.assign-driver": {
          "& button": {
            backgroundColor: "rgba(0, 174, 239, 0.1)",
            color: colors.skyblue,
          },
        },

        "&.re-assign": {
          "& button": {
            border: "1px solid #e2e2e2",
            color: colors.black,
            backgroundColor: "transparent",
          },
        },
        "& button": {
          width: "100%",
          borderRadius: "4px",
          fontWeight: "500",
        },
      },
      "& .truck-rego": {
        width: "110px",
        "& .flex-box .title-cell": {
          whiteSpace: "nowrap",
        },
      },
      "& .status": {
        width: "120px",
      },
      "& .customerName": {
        width: "160px",
      },
      "& .cto": {
        width: "100px",
      },
      "& .jobType": {
        width: "100px",
      },
      "& .cargoType": {
        width: "100px",
        "& .flex-box .title-cell": {
          whiteSpace: "nowrap",
        },
      },
      "& .date": {
        width: "115px",
      },
      "& .completion-date": {
        width: "115px",
      },
    },
    "& .flex-box": {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      marginTop: "9px",
      "& .MuiTableSortLabel-root": {
        marginTop: "5px",
      }
    },
  },
});

export { TableStyle };
